export default __webpack_public_path__ + "static/media/Lista.46cc7c88.svg";